export const ACTION_CONFIGS_VIEW = 'action-configs';

export const HELP_CENTER_ROUTE_PATHS = {
  actionConfigs: '/help-center/action-configs',
};

export const HELP_CENTER_API_PATHS = {
  list: '/v1/api/platform/help-center/action-config',
  create: '/v1/api/platform/help-center/action-config',
  update: '/v1/api/platform/help-center/action-config/:actionConfigId',
  components: '/v1/api/platform/help-center/action-config/:actionConfigId/components',
  createComponent: '/v1/api/platform/help-center/action-config/:actionConfigId/component',
  updateComponent: '/v1/api/platform/help-center/action-config/component/:componentId',
  countries: '/v1/api/platform/help-center/action-config/component/:componentId/countries',
  addCountries: '/v1/api/platform/help-center/action-config/component/:componentId/country',
  updateCountry: '/v1/api/platform/help-center/action-config/country/:countryConfigId',
};

/** Client-side page size (table pagination is done in the browser — see FETCH_SIZE below). */
export const PAGE_SIZE = 25;

/**
 * Upstream's list endpoint accepts only page/size — no filter query params — so the panel
 * fetches one large page and filters/paginates client-side (same pattern as content's
 * CATEGORIES_FETCH_SIZE) rather than showing a paginator whose totals only reflect the
 * unfiltered page.
 */
export const FETCH_SIZE = 500;

/**
 * Query keys for React Query.
 * Hierarchical structure for cache management.
 */
export const HelpCenterKeys = {
  all: () => ['help-center', 'action-configs'] as const,
  list: () => [...HelpCenterKeys.all(), 'list'] as const,
  components: (actionConfigId: number | string) =>
    [...HelpCenterKeys.all(), 'components', actionConfigId] as const,
  countries: (componentId: number | string) =>
    [...HelpCenterKeys.all(), 'countries', componentId] as const,
};
